import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a4e1e70")

_pushScopeId("data-v-1a4e1e70")
const _hoisted_1 = { class: "d-lg-flex order-content" }
const _hoisted_2 = { class: "myaccounting-actions order-lg-1 mb-lg-0" }
const _hoisted_3 = { class: "cuted-cell-two-lines" }
const _hoisted_4 = { class: "accounting-search col-lg-4 mt-auto" }
const _hoisted_5 = { class: "search-button-wrapper pl-15" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_7 = {
  class: "accounting-total-filter col-lg-4 mt-auto px-lg-2",
  style: {"align-items":"center"}
}
const _hoisted_8 = {
  class: "accounting-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_9 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "orders-filter-circle"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "mobile-grid w-100"
}
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_16 = { style: {"display":"flex","column-gap":"20px","position":"relative","top":"-8px"} }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = {
  class: "value",
  style: {"color":"#FD6A5B"}
}
const _hoisted_25 = { class: "title" }
const _hoisted_26 = {
  class: "value",
  style: {"color":"#7AD318"}
}
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = {
  key: 1,
  class: "desktop-grid table w100"
}
const _hoisted_32 = { class: "w100" }
const _hoisted_33 = { class: "t-center" }
const _hoisted_34 = { class: "desktop-table-text-setting is-link" }
const _hoisted_35 = { class: "desktop-table-text-setting" }
const _hoisted_36 = { class: "value cuted-cell-one-line" }
const _hoisted_37 = { class: "desktop-table-text-setting" }
const _hoisted_38 = { class: "desktop-table-text-setting" }
const _hoisted_39 = { class: "desktop-table-text-setting" }
const _hoisted_40 = { style: {"color":"#FD6A5B"} }
const _hoisted_41 = { class: "desktop-table-text-setting" }
const _hoisted_42 = { style: {"color":"#7AD318"} }
const _hoisted_43 = { class: "desktop-table-text-setting" }
const _hoisted_44 = { class: "desktop-table-text-setting" }
const _hoisted_45 = { class: "desktop-table-text-setting desktop-table-text-setting-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomLoader = _resolveComponent("CustomLoader")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ["businessClients-table-container container", { 'businessClients-table-container-mobile': _ctx.isMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createPerfomaInvoice && _ctx.createPerfomaInvoice(...args))),
            style: {"background":"#f6ae28"},
            class: "order-circle-btn"
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.perfomaInvoiceTitle), 1)
          ])
        ]),
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createCreditInvoice && _ctx.createCreditInvoice(...args))),
            style: {"background":"linear-gradient(180deg, #F98332 0%, #E76309 100%)"},
            class: "order-circle-btn"
          }, _toDisplayString(_ctx.$t('orderActions.newCreditInvoice')), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createInvoice && _ctx.createInvoice(...args))),
            type: "button",
            style: {"background":"linear-gradient(180deg, #FF9485 0%, #FE7C6D 100%)"},
            class: "order-circle-btn"
          }, _toDisplayString(_ctx.$t('label.invoices')), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createReceipt && _ctx.createReceipt(...args))),
            type: "button",
            style: {"background":"linear-gradient(180deg, #B1EB33 0%, #7AD318 100%)"},
            class: "order-circle-btn"
          }, _toDisplayString(_ctx.$t('accounting.receipt')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input order-input w100",
          id: "datetime",
          type: "text",
          placeholder: _ctx.$t('placeholder.searchByNameOrDocNumber'),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.keyword = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, [
            _hoisted_6
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('businessClient.totalDocuments')), 1),
          _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('businessClient.ofDocuments', { total: _ctx.total })), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("span", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["orders-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "orders-filter-btn-text w-100",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goFilter && _ctx.goFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_10
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_11, "!"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_CustomLoader, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_12, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accounts, (account, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mobile-order-product-item",
                    key: index
                  }, [
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('label.documentNumber')) + ": ", 1),
                      _createVNode("div", _hoisted_15, [
                        (account.documentType == _ctx.DocumentType.Invoice)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: {
                                    name: 'businessInvoiceView',
                                    params: { invoiceId: account.id, clientId: account.businessClientId }
                                },
                              class: "text-link"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(account.documentNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        (account.documentType == _ctx.DocumentType.Receipt)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: {
                                    name: 'businessReceiptView',
                                    params: { receiptId: account.id, clientId: account.businessClientId }
                                },
                              class: "text-link"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(account.documentNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_16, [
                          _createVNode("i", {
                            class: "icon-f icon-share fs-26 ellipsis-icon",
                            style: {"color":"#adacb7"},
                            onClick: ($event: any) => (_ctx.shareDocument(account))
                          }, null, 8, ["onClick"]),
                          _createVNode("i", {
                            class: ["icon-f icon-eye fs-26 ellipsis-icon", { 'blue-color': account.pdfUrl }],
                            onClick: ($event: any) => (_ctx.showPdf(account))
                          }, null, 10, ["onClick"])
                        ])
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('label.documentType')) + ": ", 1),
                      _createVNode("span", _hoisted_18, _toDisplayString(_ctx.getDocTypeName(account)), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('label.customer_name')) + ": ", 1),
                      _createVNode("span", _hoisted_20, _toDisplayString(account.customerName), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('label.amount')) + ": ", 1),
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.formatAmount(account.total)) + " " + _toDisplayString(account.currencySymbol), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('label.debit-in-local')) + ": ", 1),
                      _createVNode("span", _hoisted_24, _toDisplayString(account.debit == null ? '' : _ctx.formatAmount(account.debit) + ' ' + account.localCurrencySymbol), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('label.credit-in-local')) + ": ", 1),
                      _createVNode("span", _hoisted_26, _toDisplayString(account.credit == null ? '' : _ctx.formatAmount(account.credit) + ' ' + account.localCurrencySymbol), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('label.created-date')) + ": ", 1),
                      _createVNode("span", _hoisted_28, _toDisplayString(account.createdDate), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('label.creator')) + ": ", 1),
                      _createVNode("span", _hoisted_30, _toDisplayString(account.creator), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("table", _hoisted_32, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _createVNode("td", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sotrBy('DocumentNumber')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.documentNumber')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('DocumentNumber')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sotrBy('DocumentType')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.documentType')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('DocumentType')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sotrBy('CustomerName')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.customer_name')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CustomerName')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sotrBy('Amount')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.amount')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Amount')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('Debit')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.debit-in-local')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Debit')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('Credit')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.credit-in-local')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Credit')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('CreatedDate')))
                      }, [
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.created-date')) + " ", 1),
                          _createVNode("i", {
                            class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreatedDate')]
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.creator')), 1)
                      ]),
                      _createVNode("td", _hoisted_33, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.action')), 1)
                      ])
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accounts, (account, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        style: {"position":"relative"}
                      }, [
                        _createVNode("td", _hoisted_34, [
                          _createVNode("span", null, [
                            (account.documentType == _ctx.DocumentType.Invoice)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: {
                                            name: 'businessInvoiceView',
                                            params: { invoiceId: account.id, clientId: account.businessClientId }
                                        },
                                  class: "text-link"
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(account.documentNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true),
                            (account.documentType == _ctx.DocumentType.Receipt)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: {
                                            name: 'businessReceiptView',
                                            params: { receiptId: account.id, clientId: account.businessClientId }
                                        },
                                  class: "text-link"
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(account.documentNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("td", _hoisted_35, [
                          _createVNode("span", null, [
                            _createVNode("span", _hoisted_36, _toDisplayString(_ctx.getDocTypeName(account)), 1)
                          ])
                        ]),
                        _createVNode("td", _hoisted_37, [
                          _createVNode("span", null, _toDisplayString(account.customerName), 1)
                        ]),
                        _createVNode("td", _hoisted_38, [
                          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(account.total)) + " " + _toDisplayString(account.currencySymbol), 1)
                        ]),
                        _createVNode("td", _hoisted_39, [
                          _createVNode("span", _hoisted_40, _toDisplayString(account.debit == null ? '' : _ctx.formatAmount(account.debit) + ' ' + account.localCurrencySymbol), 1)
                        ]),
                        _createVNode("td", _hoisted_41, [
                          _createVNode("span", _hoisted_42, _toDisplayString(account.credit == null ? '' : _ctx.formatAmount(account.credit) + ' ' + account.localCurrencySymbol), 1)
                        ]),
                        _createVNode("td", _hoisted_43, [
                          _createVNode("span", null, _toDisplayString(account.createdDate), 1)
                        ]),
                        _createVNode("td", _hoisted_44, [
                          _createVNode("span", null, _toDisplayString(account.creator), 1)
                        ]),
                        _createVNode("td", _hoisted_45, [
                          _createVNode("i", {
                            class: "icon-f icon-share fs-26 ellipsis-icon",
                            onClick: ($event: any) => (_ctx.shareDocument(account))
                          }, null, 8, ["onClick"]),
                          _createVNode("i", {
                            class: ["icon-f icon-eye fs-26 ellipsis-icon", { 'blue-color': account.pdfUrl }],
                            onClick: ($event: any) => (_ctx.showPdf(account))
                          }, null, 10, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ]))
  ], 2))
})